import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  addConfigAttributes,
  fetchConfigById,
  updateConfigAttributes,
} from "slices/attributes/config_attributes/thunk";
import * as Yup from "yup";

const ConfigAttributesFForm: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const attribute_id = location.state?.attribute_id;
  const attribute_name = location.state?.attribute_name;
  const manage_values_id = location.state?.manage_value?.manage_values_id;
  const manage_value = location.state?.manage_value?.value;

  console.log(manage_value, "manage_value");

  const dispatch = useDispatch<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [initialData, setInitialData] = useState({
    attribute_name: "",
    existing_values: "",
  });

  const [updateId, setUpdateId] = useState<string | null>(null);

  useEffect(() => {
    if (manage_value) {
      setInitialData({
        attribute_name: attribute_name || "",
        existing_values: manage_value,
      });
    }
  }, [manage_value, attribute_name]);

  //   useEffect(() => {
  //     if (isEdit) {
  //       if (brandData) {

  //         setInitialData({
  //           attribute_name: brandData.attribute_name || "",
  //           existing_values: brandData.value || "",
  //         });
  //         setUpdateId(brandData.manage_values_id);
  //       } else if (id) {

  //         setIsLoading(true);
  //         dispatch(fetchConfigById(id))
  //           .then((res: any) => {
  //             setInitialData({
  //               attribute_name: res?.payload?.attribute_name || "",
  //               existing_values: res?.payload?.value || "",
  //             });
  //             setUpdateId(res?.payload?.id);
  //           })
  //          .catch((error: any) => {
  //   setIsLoading(false);

  //   // Safely get backend response
  //   const errData = error?.response?.data;
  //   console.log(errData,"errData----2")

  //   // If backend sends `errors` as string
  //   if (errData?.errors) {
  //     const msg = errData.errors;
  //     formik.setFieldError("attribute_name", msg); // ✅ Show under input
  //     toast.error(msg); // ✅ Show toast popup
  //   }
  //   // If only `message` exists
  //   else if (errData?.message) {
  //     toast.error(errData.message);
  //   }
  //   // Fallback error
  //   else {
  //     toast.error("Failed to save attribute");
  //   }
  // })
  // .finally(() => {
  //   setIsLoading(false);
  // });

  //     }
  //   }
  // }, [id, isEdit, brandData, dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      value: initialData.existing_values || "",
    },
    validationSchema: Yup.object({
      value: Yup.string()
        .trim()
        .required("Please enter value(s)")
        .test(
          "no-empty-values",
          "Values cannot be empty. Remove extra commas and spaces.",
          function (value) {
            if (!value) return false;
            const values = value
              .split(",")
              .map((v) => v.trim())
              .filter((v) => v.length > 0);
            return values.length > 0;
          }
        )
        .test(
          "no-duplicate-values",
          "Duplicate values are not allowed",
          function (value) {
            if (!value) return true;
            const values = value
              .split(",")
              .map((v) => v.trim().toLowerCase())
              .filter((v) => v.length > 0);
            const uniqueValues = Array.from(new Set(values));
            return values.length === uniqueValues.length;
          }
        ),
    }),
    onSubmit: async (values) => {
      // const attributeId = id || brandData?.attribute_id;
      const attributeId = manage_values_id || id; // In add brandData is id and in edit it's an {}

      // console.log(brandData)
      if (!attributeId) {
        toast.error("Attribute ID is missing!");
        return;
      }

      const cleanedValues = values.value
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v.length > 0)
        .join(",");

      if (!cleanedValues) {
        toast.error("Please provide at least one valid value");
        return;
      }

      const payload = {
        // attribute: attributeId,
        attribute: attribute_id,
        value: cleanedValues,
      };

      try {
        setIsLoading(true);

        // console.log("=== SUBMIT DEBUG INFO ===");
        // console.log("isEdit:", isEdit);
        // console.log("id from params:", id);
        // console.log("brandData:", brandData);
        // console.log("updateId:", updateId);
        // console.log("payload:", payload);
        // console.log("========================");

        if (isEdit && manage_values_id) {
          const updateData = {
            id: manage_values_id,
            payload: payload,
          };
          console.log("CALLING UPDATE API WITH:", updateData);
          await dispatch(updateConfigAttributes(updateData)).unwrap();
          toast.success("Attribute values updated successfully");
        } else {
          console.log("CALLING CREATE API WITH:", payload);
          await dispatch(addConfigAttributes(payload)).unwrap();
          toast.success("Attribute values added successfully");
        }

        navigate(-1);
      } catch (error: any) {
        console.error("=== SUBMIT ERROR ===", error);

        // Handle error response from backend
        let backendResponse = null;

        // Method 1: Direct response.data (standard Axios)
        if (error?.response?.data) {
          backendResponse = error.response.data;
        }
        // Method 2: Redux Toolkit serialized error
        else if (error?.payload) {
          backendResponse = error.payload;
        }
        // Method 3: Error might already be the response data
        else if (error?.status || error?.message || error?.errors) {
          backendResponse = error;
        }

        console.log("Extracted backend response:", backendResponse);

        let errorMessage = "";

        // Check if backend returned error data
        if (backendResponse) {
          // Your backend returns: { status, success, message, errors }
          if (backendResponse.errors) {
            errorMessage =
              typeof backendResponse.errors === "string"
                ? backendResponse.errors
                : backendResponse.errors?.value ||
                  backendResponse.errors?.non_field_errors ||
                  JSON.stringify(backendResponse.errors);
          } else if (backendResponse.message) {
            errorMessage = backendResponse.message;
          } else if (backendResponse.detail) {
            errorMessage = backendResponse.detail;
          }
        }

        // Fallback to Axios error message or generic message
        if (!errorMessage) {
          if (
            error?.message &&
            error.message !== "Request failed with status code 400"
          ) {
            errorMessage = error.message;
          } else {
            errorMessage = `Failed to ${
              isEdit && initialData.existing_values ? "update" : "save"
            } attribute values`;
          }
        }

        // Display error both in form and as toast
        formik.setFieldError("value", errorMessage);
        toast.error(errorMessage);

        console.log("Final error message displayed:", errorMessage);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="page-content px-4">
      {isEdit && isLoading ? (
        <div
          className="text-center py-5"
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "30px",
            boxShadow: "0 0 15px rgba(0,0,0,0.05)",
          }}
        >
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Loading attribute details...</p>
        </div>
      ) : (
        <div
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "30px",
            boxShadow: "0 0 15px rgba(0,0,0,0.05)",
          }}
        >
          <Form autoComplete="off" onSubmit={formik.handleSubmit}>
            <Row>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
                <div className="d-flex align-items-center gap-2">
                  <span
                    style={{ fontSize: "24px", cursor: "pointer" }}
                    onClick={() => navigate(-1)}
                  >
                    ←
                  </span>
                  <h5 className="mb-0 fw-bold">
                    {initialData.existing_values
                      ? "Edit Attribute Values"
                      : "Add Attribute Values"}
                  </h5>
                </div>

                <div className="text-muted">
                  <span
                    style={{
                      color: "inherit",
                      textDecoration: "none",
                      cursor: "pointer",
                      marginRight: 5,
                    }}
                    onClick={() => navigate(-1)}
                  >
                    Manage Value
                  </span>
                  &gt;{" "}
                  <span
                    style={{
                      color: "inherit",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    // onClick={() =>
                    //   navigate(
                    //     isEdit
                    //       ? `/edit-attribute/${id}`
                    //       : "/attribute-form"
                    //   )
                    // }
                  >
                    {initialData.existing_values
                      ? "Edit Attribute Values"
                      : "Add Attribute Values"}
                  </span>
                </div>
              </div>

              {initialData.attribute_name && (
                <Col lg={12} className="mb-3">
                  <div className="p-3 bg-light rounded">
                    <strong>Attribute:</strong> {initialData.attribute_name}
                  </div>
                </Col>
              )}

              <Col lg={12}>
                <Form.Label>
                  Attribute Values <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="value"
                  placeholder="Enter Attribute Values"
                  value={formik.values.value || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={!!formik.errors.value && formik.touched.value}
                  disabled={isLoading}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.value}
                </Form.Control.Feedback>
              </Col>
            </Row>

            <div className="d-flex justify-content-center gap-3 py-3">
              <Button
                variant="outline-secondary"
                style={{
                  color: "#878899",
                  borderColor: "#B0BAC9",
                  backgroundColor: "transparent",
                }}
                onClick={() => navigate(-1)}
                disabled={isLoading}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                className="btn"
                style={{
                  backgroundColor: "#0073BB",
                  borderColor: "#0073BB",
                  color: "#fff",
                }}
              >
                {isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    {isEdit ? "Updating..." : "Adding..."}
                  </>
                ) : (
                  <>{isEdit ? "Submit" : "Update"}</>
                )}
              </Button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
};

export default ConfigAttributesFForm;
